
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Слой_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 444 492.3","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M221.8 324.7c43.8 0 79.3 35.5 79.3 79.3s-35.5 79.3-79.3 79.3-79.3-35.5-79.3-79.3 35.5-79.3 79.3-79.3"}}),_c('circle',{staticClass:"st1",attrs:{"cx":"221.8","cy":"404","r":"79.3"}}),_c('path',{staticClass:"st2",attrs:{"d":"M221.8 62.2s-94.1-1.5-101 65.9S77.9 354.8 9 382.4h215.7"}}),_c('path',{staticClass:"st1",attrs:{"d":"M221.8 62.2s-94.1-1.5-101 65.9S77.9 354.8 9 382.4h215.7"}}),_c('path',{staticClass:"st2",attrs:{"d":"M222.1 382.4H435c-68.9-27.6-104.9-186.9-111.8-254.3-6.9-67.4-101-65.9-101-65.9"}}),_c('path',{staticClass:"st1",attrs:{"d":"M222.1 382.4H435c-68.9-27.6-104.9-186.9-111.8-254.3-6.9-67.4-101-65.9-101-65.9"}}),_c('path',{staticClass:"st0",attrs:{"d":"M198.5 57c0-17.1 10.9-48 24.3-48s24.3 30.9 24.3 48"}}),_c('path',{staticClass:"st1",attrs:{"d":"M198.5 57c0-17.1 10.9-48 24.3-48s24.3 30.9 24.3 48"}}),_c('path',{staticClass:"st3",attrs:{"d":"M321.3 48.5c52.6 0 95.3 42.7 95.3 95.3s-42.7 95.3-95.3 95.3-95.3-42.7-95.3-95.3 42.7-95.3 95.3-95.3","fill":"red"}}),_c('circle',{staticClass:"st1",attrs:{"cx":"321.3","cy":"143.8","r":"95.3"}}),_c('path',{staticClass:"st4",attrs:{"d":"M221.8 449.7c-25.2 0-45.7-20.5-45.7-45.7"}})])
          )
        }
      }
    